export default __webpack_public_path__ + "static/media/social.f2c57d08.jpg";